import React, { useEffect, useMemo, useState } from 'react';
import { Tabs } from 'antd';
import { useLocation } from 'react-router-dom';
import Header from '../../components/Header';
import DevicesTab from './components/devices/DevicesTab';
import DeviceGroupsTab from './components/device-groups/DeviceGroupsTab';



interface Tab {
  id: string;
  label: string;
}

const DeviceManagement: React.FC = () => {
  const location = useLocation();
  const tabs = useMemo<Tab[]>(
    () => [
      { id: 'devices', label: 'Devices' },
      { id: 'device-groups', label: 'Device Groups' },
    ],
  []);

  const [activeTab, setActiveTab] = useState<string>('devices');

  useEffect(() => {
    const requestedTab = (location.state as { activeTab?: string } | null)?.activeTab;

    if (requestedTab && tabs.some(tab => tab.id === requestedTab)) {
      setActiveTab(current => (current === requestedTab ? current : requestedTab));
    }
  }, [location.key, tabs]);

  const tabItems = tabs.map(tab => ({
    key: tab.id,
    label: (
      <span className="flex items-center space-x-2">
        <span>{tab.label}</span>
      </span>
    ),
    children: tab.id === 'devices' ? <DevicesTab /> : <DeviceGroupsTab />
  }));

  return (
    <div className="min-h-screen bg-background">
      <Header title='StreamCast Manager'/>
      
      <main className="pt-15 px-6 py-6">
        <div className="max-w-7xl mx-auto">

          {/* Tab Navigation */}
          <div className="mb-6">
            <Tabs
              activeKey={activeTab}
              onChange={setActiveTab}
              items={tabItems}
              className="device-management-tabs"
            />
          </div>
        </div>
      </main>
    </div>
  );
};

export default DeviceManagement;
